<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlideMedia$ | async; as media) {
  <div class="flex justify-content-center w-full h-full">
    <video #videoElement
      [src]="mediaControlService.getUrl(media)"
      class="max-w-full max-h-full"
      id="video-{{ media.id }}"
      [poster]="mediaControlService.getUrl(media, 'poster') || '/assets/images/no-image.png'"
      preload="auto"
      controls>
    </video>
  </div>
}
